"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transportReasonTemplates = void 0;
exports.transportReasonOptions = transportReasonOptions;
exports.transportReasonOptionsFlat = transportReasonOptionsFlat;
var __1 = require("..");
exports.transportReasonTemplates = ['SSR', 'PSY', 'MCO'];
var MDVTransportReasonOptions = [
    {
        options: ['MDV_CS_COVID'],
    },
    {
        label: 'Autre consultation / Examen (IRM, radio, scanner)',
        options: ['MDV_CS', 'MDV_RAD_SCAN', 'MDV_IMAGE_NOT_RAD_SCAN', 'MDV_IMAGE_AND_CS'],
    },
    {
        options: ['MDV_TSFR_URG_COVID', 'MDV_TSFR_URG', 'MDV_ENTER_HPTL', 'MDV_ENTER_HPTL_HDJ'],
    },
    { options: ['ANY_UNINSURED_PTNT', 'MDV_OTHER'] },
];
var HADTransportReasonOptions = [
    {
        label: 'Consultation / Examen (IRM, Scanner, Radio...) EN lien avec le protocole de soins',
        options: ['HAD_CS_PRTCL', 'HAD_RAD_SCAN_PRTCL', 'HAD_IMAGE_NOT_RAD_SCAN_PRTCL', 'HAD_IMAGE_AND_CS_PRTCL'],
    },
    {
        label: 'Consultation / Examen SANS lien avec le protocole de soins',
        options: [
            'HAD_CS_NOT_PRTCL',
            'HAD_RAD_SCAN_NOT_PRTCL',
            'HAD_IMAGE_NOT_RAD_SCAN_NOT_PRTCL',
            'HAD_PSY_SSR_IMAGE_AND_CS_NOT_PRTCL',
        ],
    },
    {
        label: 'Transfert vers un autre établissement',
        options: [
            'HAD_TSFR_FINAL',
            'HAD_TSFR_HPTL_TEMP_PRTCL',
            'HAD_TSFR_HPTL_TEMP_NOT_PRTCL',
            'HAD_TSFR_URG_FINAL',
            'HAD_TSFR_URG_TMP_EXAM',
        ],
    },
    {
        options: ['HAD_ENTER'],
    },
    {
        label: 'Chimio / Radiothérapie / Dialyse',
        options: [
            'HAD_CHIM_HPTL',
            'HAD_DIALYSIS_HPTL',
            'HAD_RADIO_HPTL',
            'HAD_RADIO_NOT_HPTL',
            'HAD_DIALYSIS_NOT_HPTL_PRTCL',
            'HAD_DIALYSIS_NOT_HPTL_NOT_PRTCL',
        ],
    },
    { options: ['ANY_UNINSURED_PTNT', 'OTHER'] },
];
var HDJTransportReasonOptions = [
    {
        options: ['HDJ_FROM_DOM', 'HDJ_TSFR_DOM_FROM_HDJ'],
    },
    { options: ['ANY_UNINSURED_PTNT', 'OTHER'] },
];
var UHCDTransportReasonOptions = [
    {
        options: ['URG_TSFR_UHCD_HPTL', 'URG_TSFR_HPTL', 'URG_ENTER_UHCD', 'ANY_EXIT_HPTL'],
    },
    { options: ['ANY_UNINSURED_PTNT', 'OTHER'] },
];
var EHPADTransportReasonOptions = [
    {
        label: 'Consultation / Examen (IRM, Scanner, Radiographie)',
        options: ['EHPAD_CS', 'EHPAD_RAD_SCAN', 'EHPAD_IMAGE_NOT_RAD_SCAN', 'EHPAD_IMAGE_AND_CS'],
    },
    {
        label: 'Transfert vers un établissement de santé',
        options: ['EHPAD_TSFR_FINAL', 'EHPAD_TSFR_HPTL_TEMP', 'EHPAD_TSFR_URG_FINAL', 'EHPAD_TSFR_URG_TMP_EXAM'],
    },
    {
        label: 'Chimio / Radiothérapie / Dialyse',
        options: ['EHPAD_RADIO', 'EHPAD_CHIM', 'EHPAD_DIALYSIS'],
    },
    {
        options: ['EHPAD_PERM', 'EHPAD_ENTER'],
    },
    { options: ['ANY_UNINSURED_PTNT', 'OTHER'] },
];
var DCTransportReasonOptions = [
    {
        options: [
            'DC_SESSION_FROM_HPTL',
            'DC_SESSION_FROM_DOM',
            'DC_SESSION_FROM_HAD',
            'DC_SCAN_REP',
            'DC_DIALYSIS_ENTRNMT',
            'DC_CS',
            'DC_HC_SESSION_FROM_DOM',
            'ANY_EXIT_HPTL',
        ],
    },
    { options: ['ANY_UNINSURED_PTNT', 'OTHER'] },
];
var RCTransportReasonOptions = [
    {
        options: [
            'RC_SESSION_FROM_HPTL',
            'RC_SESSION_FROM_DOM',
            'RC_SESSION_FROM_HAD',
            'RC_CENTRAGE',
            'RC_IRR_EXT',
            'ANY_EXIT_HPTL',
        ],
    },
    { options: ['ANY_UNINSURED_PTNT', 'OTHER'] },
];
var CHIMTransportReasonOptions = [
    {
        options: [
            'CHIM_SESSION_FROM_HPTL',
            'CHIM_SESSION_FROM_DOM',
            'CHIM_SESSION_FROM_HAD',
            'CHIM_CS_AND_BLOOD',
            'ANY_EXIT_HPTL',
        ],
    },
    { options: ['ANY_UNINSURED_PTNT', 'OTHER'] },
];
var HCMCOTransportReasonOptions = [
    { options: ['ANY_EXIT_HPTL'] },
    {
        label: 'Transfert vers un autre établissement pour hospitalisation',
        options: ['HC_TSFR_FINAL', 'HC_TSFR_HPTL_TEMP'],
    },
    {
        options: ['HC_ENTER_PIA'],
    },
    {
        label: 'Consultation / Examen (IRM, Scanner, Radio...)',
        options: ['HC_CS', 'HC_RAD_SCAN', 'HC_IMAGE_NOT_RAD_SCAN', 'HC_IMAGE_AND_CS'],
    },
    {
        label: 'Transfert aux urgences',
        options: ['HC_TSFR_URG_TMP_EXAM', 'HC_TSFR_URG_FINAL'],
    },
    {
        label: 'Chimio / Radiothérapie / Dialyse',
        options: ['HC_CHIM_HPTL', 'HC_DIALYSIS_HPTL', 'HC_RADIO_HPTL', 'HC_RADIO_NOT_HPTL', 'HC_DIALYSIS_NOT_HPTL'],
    },
    { options: ['HC_ENTER_HPTL', 'HC_PERM'] },
    { options: ['ANY_UNINSURED_PTNT', 'OTHER'] },
];
var HCSSRTransportReasonOptions = [
    {
        label: 'Consultation / Examen (IRM, Scanner, Radiographie)',
        options: ['HC_CS', 'HC_RAD_SCAN', 'HC_IMAGE_NOT_RAD_SCAN', 'HC_IMAGE_AND_CS'],
    },
    {
        label: 'Transfert vers un autre établissement pour hospitalisation',
        options: ['HC_TSFR_FINAL', 'HC_TSFR_HPTL_TEMP'],
    },
    {
        label: 'Transfert aux urgences',
        options: ['HC_TSFR_URG_TMP_EXAM', 'HC_TSFR_URG_FINAL'],
    },
    { options: ['ANY_EXIT_HPTL'] },
    {
        label: 'Chimio / Radiothérapie / Dialyse',
        options: ['HC_CHIM_HPTL', 'HC_DIALYSIS_HPTL', 'HC_RADIO_HPTL', 'HC_RADIO_NOT_HPTL', 'HC_DIALYSIS_NOT_HPTL'],
    },
    { options: ['HC_ENTER_HPTL', 'HC_PERM'] },
    {
        label: 'Autres raisons',
        options: [
            'HC_VISIT_EHPAD_PTNT',
            'HC_VISIT_EHPAD_HPTL',
            'ANY_RETURN_MED_DEVICE',
            'HC_VAD',
            'ANY_ACH_PRLVT',
            'ANY_UNINSURED_PTNT',
            'OTHER',
        ],
    },
];
var HCPSYTransportReasonOptions = [
    {
        label: 'Consultation / Examen (IRM, Scanner, Radiographie)',
        options: ['HC_CS', 'HC_RAD_SCAN', 'HC_IMAGE_NOT_RAD_SCAN', 'HC_IMAGE_AND_CS'],
    },
    {
        label: 'Transfert vers un autre établissement pour hospitalisation',
        options: ['HC_TSFR_FINAL', 'HC_TSFR_HPTL_TEMP'],
    },
    {
        label: 'Transfert aux urgences',
        options: ['HC_TSFR_URG_TMP_EXAM', 'HC_TSFR_URG_FINAL'],
    },
    { options: ['ANY_EXIT_HPTL'] },
    {
        label: 'Chimio / Radiothérapie / Dialyse',
        options: ['HC_CHIM_HPTL', 'HC_DIALYSIS_HPTL', 'HC_RADIO_HPTL', 'HC_RADIO_NOT_HPTL', 'HC_DIALYSIS_NOT_HPTL'],
    },
    { options: ['HC_ENTER_HPTL', 'HC_PERM'] },
    {
        label: 'Autres raisons',
        options: ['ANY_UNINSURED_PTNT', 'HC_VAD', 'OTHER'],
    },
];
var EPATransportReasonOptions = [
    {
        label: 'Consultation / Examen (IRM, Scanner, Radiographie)',
        options: [
            'EPA_CS_NOTART80',
            'EPA_RAD_SCAN_NOTART80',
            'EPA_IMAGE_NOT_RAD_SCAN_NOTART80',
            'EPA_IMAGE_AND_CS_NOTART80',
        ],
    },
    {
        label: 'Transfert vers un autre établissement pour hospitalisation',
        options: ['EPA_TSFR_FINAL_GOV', 'EPA_TSFR_HPTL_TEMP_NOTART80'],
    },
    {
        label: 'Transfert aux urgences',
        options: ['EPA_TSFR_URG_TMP_EXAM_NOTART80', 'EPA_TSFR_URG_FINAL_GOV'],
    },
    { options: ['ANY_EXIT_HPTL'] },
    {
        label: 'Chimio / Radiothérapie / Dialyse',
        options: ['EPA_CHIM_HPTL', 'EPA_DIALYSIS_HPTL', 'EPA_RADIO_HPTL', 'EPA_RADIO_NOT_HPTL', 'EPA_DIALYSIS_HPTL'],
    },
    { options: ['EPA_ENTER_HPTL', 'EPA_PERM_NOTART80'] },
    {
        label: 'Autres raisons',
        options: [
            'EPA_VISIT_EHPAD_PTNT',
            'EPA_VISIT_EHPAD_NOTART80',
            'ANY_RETURN_MED_DEVICE',
            'EPA_VAD_NOTART80',
            'ANY_ACH_PRLVT',
            'ANY_UNINSURED_PTNT',
            'OTHER',
        ],
    },
];
function getTransportReasonsTemplate(hospitalType, transportReasonTemplate) {
    switch (hospitalType) {
        // biome-ignore lint/suspicious/noFallthroughSwitchClause: assertUnreachable will prevent fallthrough
        case 'FULL':
            switch (transportReasonTemplate) {
                case 'PSY':
                    return HCPSYTransportReasonOptions;
                case 'SSR':
                    return HCSSRTransportReasonOptions;
                case 'MCO':
                    return HCMCOTransportReasonOptions;
            }
            (0, __1.assertUnreachable)(transportReasonTemplate);
        case 'URG':
            return UHCDTransportReasonOptions;
        case 'EHPAD':
            return EHPADTransportReasonOptions;
        case 'HDJ':
            return HDJTransportReasonOptions;
        case 'HAD':
            return HADTransportReasonOptions;
        case 'DC':
            return DCTransportReasonOptions;
        case 'RC':
            return RCTransportReasonOptions;
        case 'CHIM':
            return CHIMTransportReasonOptions;
        case 'MDV':
            return MDVTransportReasonOptions;
        case 'EPA':
            return EPATransportReasonOptions;
    }
    (0, __1.assertUnreachable)(hospitalType);
}
function flattenOptions(groups) {
    var flattenedOptions = [];
    groups.forEach(function (group) {
        flattenedOptions.push.apply(flattenedOptions, group.options);
    });
    return flattenedOptions;
}
function transportReasonOptions(hospitalType, transportReasonTemplate) {
    return getTransportReasonsTemplate(hospitalType, transportReasonTemplate);
}
function transportReasonOptionsFlat(hospitalType, transportReasonTemplate) {
    return flattenOptions(getTransportReasonsTemplate(hospitalType, transportReasonTemplate));
}
//# sourceMappingURL=templates.js.map